import { createStore } from 'vuex'
import axios from 'axios'

const store = createStore({
    state() {
        return {
            name: 'kim',
            age: 20,
            likes: 30,
            more: {},
        }
    },
    mutations: {
        setMore(state, data) {
            state.more = data;
            console.log(state.more);
        },
        이름변경(state, name) {
            state.name = name;
        },
        증가(state, data) {
            state.age += data;
        },
        좋아요증가(state) {
            state.likes++;
        },
        좋아요감소(state) {
            state.likes--;
        }
    },
    actions: {
        // 모든 ajax 요청은 여기서 함
        getDate() {
            axios.get(`https://codingapple1.github.io/vue/more0.json`)
                .then((result) => { //애로우 펑션으로 사용하면 this를 재정의 하지 않고 밖에 있는걸 잘씀
                    //요청성공시 실행할 코드 ~~
                    // console.log(result.data);
                    this.commit('setMore', result.data);
                })
                .catch((err) => {
                    console.log(err.message);
                })
        }
    }
})

export default store